export const useLogo = () => useState<string>('logo', () => '')
export const useCss = () => useState<string>('css', () => '')
export const useTeljoyLogo = () => useState<string>('teljoyLogo', () => '')
export const useFlexiOwnLogo = () => useState<string>('flexiOwnLogo', () => '/assets/images/svg/flexiown-logo.svg')
export const useNoImage = () => useState<string>('useNoImage', () => '/assets/images/jpg/no-image.jpg')
export const useMerchantName = () => useState<string>('merchantName', () => '')
export const useDebug = () => useState<boolean>('debug', () => {
    const runtimeConfig = useRuntimeConfig();
    return runtimeConfig.debug;
})
export const useNavigation = () => useState<Array<any>>('navigation', () => [])
export const useCellphone = () => useState<string>('cellphone', () => '')
export const useAmountDue = () => useState<string>('amount', () => '')
export const useFullVetting = () => useState<boolean>('fullVetting', () => false)
export const useFraudComplete = () => useState<boolean>('fraudComplete', () => false)
